import { httpsCallable } from "firebase/functions";
import { doc, getDoc } from "firebase/firestore";
import { functions, db } from "../firebase";

function callableError(err) {
  return err?.message || err?.details || "Request failed.";
}

export async function createSubscriptionPaymentIntent({ creatorId, tier, creatorName }) {
  try {
    const fn = httpsCallable(functions, "createSubscriptionPaymentIntent");
    const { data } = await fn({ creatorId, tier, creatorName });
    return data;
  } catch (err) {
    throw new Error(callableError(err));
  }
}

export async function confirmSubscriptionCreated({
  subscriptionId,
  creatorId,
  tier,
  creatorName,
}) {
  try {
    const fn = httpsCallable(functions, "confirmSubscriptionCreated");
    const { data } = await fn({ subscriptionId, creatorId, tier, creatorName });
    return data;
  } catch (err) {
    throw new Error(callableError(err));
  }
}

export async function cancelCreatorSubscription({ creatorId }) {
  try {
    const fn = httpsCallable(functions, "cancelCreatorSubscription");
    const { data } = await fn({ creatorId });
    return data;
  } catch (err) {
    throw new Error(callableError(err));
  }
}

export async function getUserCreatorSubscription(uid, creatorId) {
  if (!uid || !creatorId) return null;
  const snap = await getDoc(doc(db, "users", uid, "subscriptions", creatorId));
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
}
